import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error but don't show it to users for DOM manipulation errors
    // These are often caused by browser extensions
    const isDomError = error?.message?.includes('removeChild') || 
                       error?.message?.includes('insertBefore') ||
                       error?.message?.includes('appendChild');
    
    if (isDomError) {
      console.warn('DOM manipulation error (likely browser extension):', error);
      // Reset the error state for DOM errors
      this.setState({ hasError: false, error: null });
      return;
    }
    
    console.error('Application error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md text-center">
            <h2 className="text-xl font-bold text-slate-900 mb-2">
              Si è verificato un errore
            </h2>
            <p className="text-slate-600 mb-4">
              Ricarica la pagina per continuare.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-slate-900 text-white px-4 py-2 rounded-lg hover:bg-slate-800"
            >
              Ricarica Pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
